import { addActivityLog } from '../data/staff/activityLogsStore';
import { getCurrentStaff } from './staffAccess';

export function logCurrentStaffActivity(entry) {
  const staff = getCurrentStaff();
  return addActivityLog({
    staffId: staff?.staffId || 'SYSTEM',
    staffName: staff?.fullName || 'System',
    ...entry,
  });
}
